import { Navigate } from "react-router-dom"

import { guestRoutes } from "~/ui-rtk/constants/routes"

/**
 * Guest entry point for the Share of Search funnel (linked from the marketing
 * site). Since APP-488 every self-serve signup IS the SoS funnel — the form
 * always sends signupSource, so no query param is needed; the API stamps the
 * user's first company SOS_FREE server-side (company.service).
 */
export default function ShareOfSearchStart() {
  return <Navigate to={guestRoutes.CREATE_ACCOUNT} replace />
}
